<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left></left>
            <recordContent></recordContent>
        </div>
    </div>
</template>

<script>
import top from '../components/top.vue' //顶部
import left from '../components/left.vue' //左侧
import recordContent from '../components/record_content.vue' //购买记录
export default {
    components: {
        top, left, recordContent
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        }
    }
}
</script>

<style>
#record {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
    position: relative;
}

.mian {
    display: flex;
    min-width: 1500px;
}
</style>